module.exports = __webpack_public_path__ + "img/img44.d67d8d91.svg";